import { DividerWrapper } from "./styles"

const Divider = DividerWrapper

export default Divider
